import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import {
  Btns,
  ButtonL,
  CheckBoxWrap,
  Content,
  FlexBox,
  Section,
  TextDiv,
} from "../../styles/Common";
import { ReactComponent as ArrowRight } from "../../styles/images/ico_arrow.svg";
import { styled } from "styled-components";
import ViewModal from "../../components/modal/ViewModal";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";

const TermsOfUse = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.auth.signUpInfo_eulas);
  const [viewMode, setViewMode] = useState(false);
  const [viewTitle, setViewTitle] = useState("");
  const [target, setTarget] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [allAgreed, setAllAgreed] = useState(false);
  const [agreements, setAgreements] = useState({
    eulaAge: data.eulaAge || false,
    eulaTerms: data.eulaTerms || false,
    eulaPrivacy: data.eulaPrivacy || false,
    // eula3rd: data.eula3rd || false,
    eulaMarketing: data.eulaMarketing || false,
  });

  useEffect(() => {
    if (agreements.eulaAge && agreements.eulaTerms && agreements.eulaPrivacy) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }

    const allChecked = Object.values(agreements).every(
      (value) => value === true
    );
    setAllAgreed(allChecked);
  }, [agreements]);

  const handleAgreementChange = (e) => {
    const { name, checked } = e.target;

    setAgreements((prev) => ({ ...prev, [name]: checked }));
    dispatch(authActions.agreeEula({ name, checked }));
    const allChecked = Object.values({ ...agreements, [name]: checked }).every(
      (value) => value === true
    );
    setAllAgreed(allChecked);
  };

  const handleAllAgreementChange = (e) => {
    const { checked } = e.target;

    setAgreements((prev) =>
      Object.keys(prev).reduce(
        (newAgreements, agreementKey) => ({
          ...newAgreements,
          [agreementKey]: checked,
        }),
        {}
      )
    );

    dispatch(authActions.allAgreeEula(checked));

    setAllAgreed(checked);
  };

  return (
    <>
      {viewMode && (
        <ViewModal
          title="이용약관"
          setAgreements={setAgreements}
          setViewMode={setViewMode}
          target={target}
        />
      )}
      <OnePageLayout title="이용약관">
        <Section>
          <Content>
            <TextDiv>
              <h3>아래 항목을 확인해 주세요.</h3>
            </TextDiv>

            <Detail>
              <AllAgreeWrap>
                <CheckBoxWrap>
                  <input
                    type="checkbox"
                    name="allAgree"
                    id="allAgree"
                    checked={allAgreed}
                    onChange={handleAllAgreementChange}
                  />
                  <label htmlFor="allAgree">모두 동의합니다.</label>
                </CheckBoxWrap>
              </AllAgreeWrap>
              <AgreeWrap>
                <LabelWarp>
                  <CheckBoxWrap>
                    <input
                      type="checkbox"
                      name="eulaAge"
                      id="eulaAge"
                      checked={agreements.eulaAge}
                      onChange={handleAgreementChange}
                    />
                    <label htmlFor="eulaAge">
                      만 14세 이상 확인 <span className="col"> [필수]</span>
                    </label>
                  </CheckBoxWrap>
                  {/* <ArrowRight
                    onClick={() => {
                      setTarget("eulaAge");
                      setViewMode(true);
                    }}
                  /> */}
                </LabelWarp>
                <LabelWarp>
                  <CheckBoxWrap>
                    <input
                      type="checkbox"
                      name="eulaTerms"
                      id="eulaTerms"
                      checked={agreements.eulaTerms}
                      onChange={handleAgreementChange}
                    />
                    <label htmlFor="eulaTerms">
                      서비스 이용 약관 동의 <span className="col"> [필수]</span>
                    </label>
                  </CheckBoxWrap>
                  <ArrowRight
                    onClick={() => {
                      setTarget("eulaTerms");
                      setViewMode(true);
                    }}
                  />
                </LabelWarp>
                <LabelWarp>
                  <CheckBoxWrap>
                    <input
                      type="checkbox"
                      name="eulaPrivacy"
                      id="eulaPrivacy"
                      checked={agreements.eulaPrivacy}
                      onChange={handleAgreementChange}
                    />
                    <label htmlFor="eulaPrivacy">
                      개인정보 처리방침 동의{" "}
                      <span className="col"> [필수]</span>
                    </label>
                  </CheckBoxWrap>
                  <ArrowRight
                    onClick={() => {
                      setTarget("eulaPrivacy");
                      setViewMode(true);
                    }}
                  />
                </LabelWarp>
                {/* <LabelWarp>
                  <CheckBoxWrap>
                    <input
                      type="checkbox"
                      name="eula3rd"
                      id="eula3rd"
                      checked={agreements.eula3rd}
                      onChange={handleAgreementChange}
                    />
                    <label htmlFor="eula3rd">
                      개인정보처리 위탁 동의{" "}
                      <span className="col"> [필수]</span>
                    </label>
                  </CheckBoxWrap>
                  <ArrowRight
                    onClick={() => {
                      setTarget("eula3rd");
                      setViewMode(true);
                    }}
                  />
                </LabelWarp> */}
                <LabelWarp>
                  <CheckBoxWrap>
                    <input
                      type="checkbox"
                      name="eulaMarketing"
                      id="eulaMarketing"
                      checked={agreements.eulaMarketing}
                      onChange={handleAgreementChange}
                    />
                    <label htmlFor="eulaMarketing">
                      마케팅 수신 동의 <span className="col"> [선택]</span>
                    </label>
                  </CheckBoxWrap>
                  <ArrowRight
                    onClick={() => {
                      setTarget("eulaMarketing");
                      setViewMode(true);
                    }}
                  />
                </LabelWarp>
              </AgreeWrap>
            </Detail>
          </Content>
          <Btns>
            <ButtonL
              onClick={() => {
                if (btnDisabled) return;
                navigate("/sign-up/add-user-info");
              }}
              disabled={btnDisabled}
            >
              동의하고 계속하기
            </ButtonL>
          </Btns>
        </Section>
      </OnePageLayout>
    </>
  );
};

export default TermsOfUse;

const AllAgreeWrap = styled.div`
  padding: 1rem 0 2rem 0;
  border-bottom: 1px solid #000;
`;

const AgreeWrap = styled.ul`
  margin-top: 1rem;
`;

const LabelWarp = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;

  label {
    font-size: 1.4rem;
    line-height: 1.4rem;

    span {
      margin-left: 0.5rem;
    }
  }
`;

const Detail = styled.div`
  margin-top: 5rem;
`;

export { AllAgreeWrap, AgreeWrap, LabelWarp, Detail };
